import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CharactersSection from '../common/components/characters/characters.component';
import { MinusIcon } from '../common/components/icons/minus-icon.component';
import { PlusIcon } from '../common/components/icons/plus-icon.component';
import { getFaqItems } from './faq.data.component';

const FaqSection = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const FAQ_ITEMS = getFaqItems(t);

  const toggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="w-full md:mt-[47px] md:px-[72px] ">
      <div className="flex flex-col gap-[20px] mb-[23px] md:mb-[33px]">
        {FAQ_ITEMS.map(({ question, answer, image, imageAlt }, index) => (
          <div key={index} className="border-b border-blue-100">
            <button
              className="w-full flex justify-between items-center pl-[24px] pr-[26px] md:pl-[12px] md:pr-[14px] pb-[16px] text-left"
              onClick={() => toggle(index)}
            >
              <p className="text-base-black font-body text-[16px] md:text-[18px] font-medium">
                {question}
              </p>

              <span className="text-blue-900">
                {activeIndex === index ? <MinusIcon /> : <PlusIcon />}
              </span>
            </button>

            {activeIndex === index && (
              <div className="pb-[18px] pl-[24px] pr-[24px] md:pl-[12px]">
                <p className="text-slate-500 font-body text-[14px] md:text-[16px] transition-all duration-300">
                  {answer}
                </p>
                {image && (
                  <img
                    src={image}
                    alt={imageAlt ?? ''}
                    className="mt-[14px] rounded-[8px] border border-gray-200 max-w-full"
                  />
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <CharactersSection />
    </section>
  );
};

export default FaqSection;
